import Vue from 'vue'
import App from './App.vue'
import router from '../../router'
import vuetify from '../../plugins/vuetify';
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import api from '@/api'
import FirstAlertSocket from "@/socket";
import axios from 'axios';
import VueMask from 'v-mask';

Vue.config.productionTip = false

const FirstAlertUtils = {
    formatPhone: function(phoneNumber) {
        if (phoneNumber && phoneNumber != '') {
            let p = String(phoneNumber.replaceAll(/[^0-9]/g,''));
            if (p.length == 10) {
                return "("+p.substring(0,3)+") "+p.substring(3,6)+"-"+p.substring(6);
            } else {
                return p;
            }
        } else {
            return phoneNumber;
        }
    },
}

const PermissionHolder = {
  permissions: [],
  hasPermission(perm) {
    return this.permissions.indexOf(perm) > -1;
  },
  load() {
    const that = this;
    return new Promise((resolve,reject) => {
      api.permission.search().then(p => {that.permissions = p; resolve()}).catch(() => {reject()});
    })
  }
}

const UserHolder = {
  user: {},
  primaryOrg: {},
  getUserId() {
    return this.user.id
  },
  getPrimaryOrganizationName() {
    return this.primaryOrg.name;
  },
  getPrimaryOrganizationId() {
    return this.primaryOrg.id;
  },
  getUserName() {
    let name = '';
    if (this.user.firstName) {
      name+=this.user.firstName + ' ';
    }
    if (this.user.lastName) {
      name+=this.user.lastName;
    }
    return name.trim();
  },
  load() {
    return new Promise((resolve,reject) => {
      api.userProfile.get().then((user) => {
        this.user = user;
        api.userProfile.organization.primary.get().then((org) => {
          this.primaryOrg = org;
          resolve();
        });
      }).catch(()=>{reject()});
    });
  }
}

FirstAlertUtils.install = function(Vue,options) {
    Object.defineProperty(Vue.prototype, '$firstAlertUtils', {
        get() {return FirstAlertUtils}
    });
}


PermissionHolder.install = function(Vue,options) {
  Object.defineProperty(Vue.prototype, '$permissionHolder', {
    get() {return PermissionHolder}
  });
}

UserHolder.install = function(Vue,options) {
  Object.defineProperty(Vue.prototype, '$userHolder', {
    get() {return UserHolder}
  });
}


FirstAlertSocket.install = function(Vue,options) {
  Object.defineProperty(Vue.prototype, '$socket', {
    get() {return FirstAlertSocket}
  });
}

Vue.use(PermissionHolder);
Vue.use(FirstAlertSocket);
Vue.use(FirstAlertUtils);
Vue.use(UserHolder);
Vue.use(VueMask);

axios.defaults.baseURL = process.env.VUE_APP_SERVER_URL;

new Vue({
  router,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
